import Select from 'components/Common/Form/Input/Select'
import TextInput from 'components/Common/Form/Input/TextInput'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Group from 'components/utils/Group'
import React from 'react'

function ContentfulFormField(props: Omit<App.ComponentFormField, 'contentTypeId'>) {
  const { type, label, placeholder, isRequired, options } = props

  const renderField = () => {
    switch (type) {
      case 'email':
        return <TextInput type="email" placeholder={placeholder} label={label} name={label} required={isRequired} />
      case 'text':
        return <TextInput type="text" placeholder={placeholder} label={label} name={label} required={isRequired} />
      case 'checkbox':
        return <Group direction="horizontal" verticalAlign="center">
          <CheckboxInput required={isRequired} name={label}> {label}</CheckboxInput>
        </Group>
      case 'select':
        if (!options) return <body>Error: `options` is required.</body>
        return (
          <Select label={label} required={isRequired} name={label}>
            {options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </Select>
        )
      default:
        return <div>Not Supported Form Field</div>
    }
  }

  return (
    <>
      {renderField()}
    </>
  )
}

export default ContentfulFormField
